module.exports = __webpack_public_path__ + "img/wx_pay.4d67a4e8.jpg";